/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'settings': {
    width: 11,
    height: 10,
    viewBox: '0 0 11 10',
    data: '<g _fill="#FFF" fill-rule="evenodd"><path pid="0" d="M0 8h2v.933H0V8zm4 0h6.666v.933H4V8z"/><path pid="1" d="M3 7.334a1 1 0 100 2 1 1 0 000-2zm0-.668A1.667 1.667 0 103 10a1.667 1.667 0 000-3.334zm5.666-2h2v.668h-2v-.668zM0 4.666h6.666v.668H0v-.668z"/><path pid="2" d="M7.666 4a1 1 0 100 2 1 1 0 000-2zm0-.666a1.666 1.666 0 100 3.332 1.666 1.666 0 000-3.332zM4 1.334h6.666V2H4v-.666zm-4 0h2V2H0v-.666z"/><path pid="3" d="M3 .666a1 1 0 100 2 1 1 0 000-2zM3 0a1.667 1.667 0 100 3.334A1.667 1.667 0 003 0z"/></g>'
  }
})
